import React, { PureComponent } from 'react';

import { SelectField } from '@eventbrite/eds-input-field';

import { AU_STATES_FOR_SELECT_FIELD } from '../../constants';

import CountryHeader from '../CountryHeader';
import CountrySections from '../CountrySections';

import {
    QueenslandInfo,
    NewSouthWalesInfo,
    TasmaniaInfo,
    WesternAustraliaInfo,
} from './AustraliaStateInfo';

const STATE_MAP = {
    'new-south-wales': NewSouthWalesInfo,
    queensland: QueenslandInfo,
    tasmania: TasmaniaInfo,
    'western-australia': WesternAustraliaInfo,
};

const CASH_FLOW_SECTION = {
    title: 'Cash Flow Boost for Employers',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>
                    Provide up to $25,000 back to small and medium-sized
                    businesses, with a minimum payment of $2,000 for eligible
                    businesses.
                </li>
                <li>
                    Payment will provide cash flow support to businesses with a
                    turnover of less than $50 million that employ staff.
                </li>
                <li>Payment will be tax free.</li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Australian Government: Economic Response to the Coronavirus',
            url: 'https://treasury.gov.au/sites/default/files/2020-03/Overview-Economic_Response_to_the_Coronavirus.pdf',
        },
    ],
};

const TAXATION_SECTION = {
    title: 'Taxation Relief Options by the Australian Taxation Office',
    content: (
        <div>
            <p>
                The Australian Taxation Office is providing several relief
                options for businesses, including payment deferrals, monthly GST
                credits, etc.
            </p>
            <p>
                For more info, visit the link below or call the emergency help
                hotline 1800 806 218
            </p>
        </div>
    ),
    links: [
        {
            title: 'Australian Taxation Office Support',
            url: 'https://www.ato.gov.au/Individuals/Dealing-with-disasters/In-detail/Specific-disasters/COVID-19/',
        },
    ],
};

const APPRENTICE_SECTION = {
    title: 'Support for Apprentices and Trainees',
    content: (
        <p>
            Eligible employers can apply for a wage subsidy of 50 per cent of
            the apprentice’s or trainee’s wage for up to 9 months from 1 January
            2020 to 30 September 2020.
            <br />
            <br />
            Where a small business is not able to retain an apprentice, the
            subsidy will be available to a new employer that employs that
            apprentice.
        </p>
    ),
    links: [],
};

const ASSET_WRITE_OFF_SECTION = {
    title: 'Instant Asset Write-offs',
    content: (
        <p>
            The government is increasing the instant asset write-off (IAWO)
            threshold from $30,000 to $150,000 and expanding access to include
            businesses with aggregated annual turnover of less than $500 million
            (up from $50 million).
        </p>
    ),
    links: [],
};

const BACKING_BUSINESS_SECTION = {
    title: 'Backing Business Incentives',
    content: (
        <div>
            <p>
                The government is introducing a time limited 15-month investment
                incentive to support business investment and economic growth
                over the short-term, by accelerating depreciation deductions.
            </p>
            <br />
            <p>
                A deduction of 50% of the cost of an eligible asset on
                installation will apply, with existing depreciation rules
                applying to the balance of the asset’s cost.
            </p>
        </div>
    ),
    links: [],
};

const AUSTRALIA_INFO = {
    countryName: 'Australia',
    lastUpdated: 'March 21, 2020',
    introSection: (
        <p>
            Australia has multiple different financial assistance options
            available. Please look over this information and follow up as
            appropriate.
        </p>
    ),
    sections: [
        CASH_FLOW_SECTION,
        TAXATION_SECTION,
        APPRENTICE_SECTION,
        ASSET_WRITE_OFF_SECTION,
        BACKING_BUSINESS_SECTION,
    ],
};

class AustraliaInfo extends PureComponent {
    state = {
        stateSelected: 'new-south-wales',
    };

    _handleStateSelect = (stateSelected) => {
        this.setState({
            stateSelected,
        });
    };

    render() {
        const { stateSelected } = this.state;

        const StateInfo = STATE_MAP[stateSelected];

        return (
            <div className="eds-g-group">
                <CountryHeader info={AUSTRALIA_INFO} />
                <CountrySections sections={AUSTRALIA_INFO.sections} />

                <div>
                    <div className="eds-g-cell eds-g-cell-mn-4-12 eds-g-sm-cell-1-1 eds-l-pad-right-12">
                        <h3 className="eds-text-hs">
                            State by State Stimulus Packages & Policies
                        </h3>
                        <p>
                            Some states offer local financial relief for their
                            businesses:
                        </p>
                        <div className="covid-selector">
                            <SelectField
                                label="State"
                                placeholder="Select a state"
                                values={AU_STATES_FOR_SELECT_FIELD}
                                onChange={this._handleStateSelect}
                                defaultValue={stateSelected}
                            />
                        </div>
                    </div>
                    <div className="eds-g-cell eds-g-cell-mn-8-12 eds-g-sm-cell-1-1">
                        <a name="state"></a>
                        {stateSelected && (
                            <div>
                                <StateInfo />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default AustraliaInfo;
